/**
 * @generated SignedSource<<544829220df0497d712df270fb8abf2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type similarityPage_Query$variables = Record<PropertyKey, never>;
export type similarityPage_Query$data = {
  readonly ruleClusters: ReadonlyArray<{
    readonly id: string;
    readonly ratio: number;
    readonly ruleA: {
      readonly destinationBankAccount: {
        readonly id: string;
        readonly name: string;
        readonly nickname: string;
      } | null | undefined;
      readonly id: string;
      readonly regex: string;
      readonly stakeholder: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly targetClassification: string | null | undefined;
      readonly targetType: string;
    };
    readonly ruleB: {
      readonly destinationBankAccount: {
        readonly id: string;
        readonly name: string;
        readonly nickname: string;
      } | null | undefined;
      readonly id: string;
      readonly regex: string;
      readonly stakeholder: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly targetClassification: string | null | undefined;
      readonly targetType: string;
    };
    readonly sameTarget: boolean;
  }>;
};
export type similarityPage_Query = {
  response: similarityPage_Query$data;
  variables: similarityPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "regex",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "targetType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "targetClassification",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Stakeholder",
    "kind": "LinkedField",
    "name": "stakeholder",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "BankAccount",
    "kind": "LinkedField",
    "name": "destinationBankAccount",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nickname",
        "storageKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RuleCluster",
    "kind": "LinkedField",
    "name": "ruleClusters",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ratio",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sameTarget",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Rule",
        "kind": "LinkedField",
        "name": "ruleA",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Rule",
        "kind": "LinkedField",
        "name": "ruleB",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "similarityPage_Query",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "similarityPage_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "da59e10be82c13975630d090dc48aa71",
    "id": null,
    "metadata": {},
    "name": "similarityPage_Query",
    "operationKind": "query",
    "text": "query similarityPage_Query {\n  ruleClusters {\n    id\n    ratio\n    sameTarget\n    ruleA {\n      id\n      regex\n      targetType\n      targetClassification\n      stakeholder {\n        id\n        name\n      }\n      destinationBankAccount {\n        id\n        nickname\n        name\n      }\n    }\n    ruleB {\n      id\n      regex\n      targetType\n      targetClassification\n      stakeholder {\n        id\n        name\n      }\n      destinationBankAccount {\n        id\n        nickname\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e5a8c0d85b2a94642e8cf386096e2669";

export default node;
